const ACTIVITY_STORAGE_KEY='amp-event-activity';

function readAllActivity() {
  try {
    return JSON.parse(localStorage.getItem(ACTIVITY_STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function writeAllActivity(activity) {
  localStorage.setItem(ACTIVITY_STORAGE_KEY,JSON.stringify(activity));
}

export function getEventActivity(eventId,event) {
  const allActivity=readAllActivity();
  const stored=allActivity[eventId];

  if (stored?.length) {
    return stored;
  }

  return [{
    id: `event-created-${eventId}`,
    type: 'created',
    title: 'Event created',
    description: `${event.name || 'This event'} was added to the workspace.`,
    createdAt: new Date().toISOString()
  }];
}

export function addEventActivity(eventId,activity) {
  const allActivity=readAllActivity();
  const current=allActivity[eventId] || [];

  const next={
    id: `activity-${Date.now()}`,
    createdAt: new Date().toISOString(),
    ...activity
  };

  allActivity[eventId]=[next,...current];
  writeAllActivity(allActivity);
  return next;
}